import { useEffect } from "react";

import { onBimIndexLetGo } from "features/bimIndex";

import { useOfflineSceneDirName } from "./useOfflineSceneKey";
import { useReplaceDataAccessWithoutOffline } from "./useReplaceDataAccessWithoutOffline";

/**
 * When another tab deletes the open scene, its downloaded BIM index goes from under the object
 * data access, which can't fall back on its own. This replaces it with what the scene has without
 * the index, as this tab's own delete does.
 */
export function useReplaceDataAccessWhenBimIndexLetGo() {
    const sceneDirName = useOfflineSceneDirName();
    const replaceDataAccess = useReplaceDataAccessWithoutOffline();

    useEffect(
        () =>
            onBimIndexLetGo((letGo) => {
                if (letGo === sceneDirName) {
                    void replaceDataAccess();
                }
            }),
        [sceneDirName, replaceDataAccess],
    );
}
